// Declared twice so that docs appear when selecting colors
export interface InfraredPalette extends Record<string, string> {
  /** **#FEEBE0** Orange */
  readonly infrared10: string;
  /** **#FFD9C4** Orange */
  readonly infrared30: string;
  /** **#FFB88D** Orange */
  readonly infrared60: string;
  /** **#FB7E34** Orange */
  readonly infraredPrimary: string;
  /** **#E25F12** Orange */
  readonly infrared80: string;
  /** **#AA3F00** Orange */
  readonly infrared90: string;
}

export const infraredPalette: InfraredPalette = {
  infrared10: '#FEEBE0',
  infrared30: '#FFD9C4',
  infrared60: '#FFB88D',
  infraredPrimary: '#FB7E34',
  infrared80: '#E25F12',
  infrared90: '#AA3F00',
};
